const UserCanAccess = function(accessType, accessName ){

    // GET ACCESS HASH FROM LOCAL STORAGE
    const accountParams = JSON.parse(localStorage.getItem('account'))
    // console.log(accountParams)
    if(accountParams.active_licence_and_contract){
        if(accountParams.licence.access[accessType]){
            return accountParams.licence.access[accessType][accessName]
        }else{
            return false
        }
    }else{
        return false
    }

}
export default UserCanAccess